export default {
  props: {
    href: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    darkModifier() {
      return {
        'link-tile--dark': this.isDark,
      };
    },
    titleModifier() {
      return {
        'link-tile__content-title--big': !this.subtitle,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/link-tile/link-tile.js